<script>
  export let pid;

  const domain = `${location.protocol}//${document.domain}`;
  let postData;

  //WordPress REST APIからカスタム投稿情報を取得
  const fetchPost = async () => {
    try {
      await fetch(`${domain}/wp-json/wp/v2/shopbrand/${pid}`)
        .then((response) => response.json())
        .then((data) => postData = data);
    } catch (error) {
      console.log(error);
    }
  };
  fetchPost();

</script>

{#await fetchPost() then response}
  {#if postData.info.free_field}
    <div class="inner editor_front">
        {@html postData.info.free_field}
    </div>
  {/if}
{/await}
